import { Box, Typography, Grid, Paper } from '@mui/material';
import { FaRegUserCircle, FaBullhorn, FaGift } from 'react-icons/fa';
import { MdOutlineCreate, MdOutlineShare, MdUpdate } from 'react-icons/md';
import COLORS from '../../../../../constants/colors';
import { ReactComponent as FundraiserTipsIllustration } from '../../../../../assets/svg/tips.svg';
import Header from '../../../../Reusable/Header';
import Footer from '../../../../Reusable/Footer';
const tips = [
    {
        icon: <MdOutlineCreate size={40} color={COLORS.primary} />,
        title: 'Tell Your Story Compellingly',
        description: 'Your campaign story is the heart of your fundraiser. Be honest, heartfelt, and clear about why you need the funds. Include specific details about your goal and how donations will make a tangible difference in your life or for your cause.'
    },
    {
        icon: <FaRegUserCircle size={40} color={COLORS.primary} />,
        title: 'Use High-Quality Visuals',
        description: 'A picture is worth a thousand words. Add high-quality, personal photos and a video to your campaign page. Visual content helps potential donors connect with your story on a deeper, more emotional level.'
    },
    {
        icon: <MdOutlineShare size={40} color={COLORS.primary} />,
        title: 'Share, Share, Share!',
        description: 'Don\'t be shy! Share your fundraiser widely with your network. Use social media, email, WhatsApp, and even word of mouth. Ask friends and family to share it with their networks as well. The more people who see your campaign, the more likely you are to succeed.'
    },
    {
        icon: <MdUpdate size={40} color={COLORS.primary} />,
        title: 'Post Regular Updates',
        description: 'Keep your supporters engaged and informed. Post regular updates on your progress, new milestones, and how the funds are being used. This transparency builds trust and encourages people to share your campaign again and again.'
    },
    {
        icon: <FaBullhorn size={40} color={COLORS.primary} />,
        title: 'Set a Realistic Goal',
        description: 'Setting a clear, achievable fundraising goal is crucial. It gives your supporters a target to rally behind and a sense of accomplishment as they see the progress. You can always increase your goal later if you reach it sooner than expected!'
    },
    {
        icon: <FaGift size={40} color={COLORS.primary} />,
        title: 'Thank Your Donors',
        description: 'Show your gratitude! Thank every donor, publicly or privately. A simple thank you message goes a long way in making people feel appreciated and can inspire others to contribute. It also encourages repeat donations and builds a community of support.'
    },
];

const FundraisingTipsPage = () => {
    return (
        <>
        <Header />
        <Box sx={{ py: 10, px: 3, maxWidth: 1200, margin: '0 auto', textAlign: 'center' }}>
            <Typography variant="h4" fontWeight="bold" color={COLORS.primary} mb={2}>
                Tips for a Successful Fundraiser
            </Typography>
            <Typography variant="body1" color={COLORS.text} mb={6}>
                A great fundraiser starts with a great plan. Follow these tips to maximize your chances of success on Yamba.
            </Typography>

            <Grid container spacing={6} alignItems="center">
                <Grid item xs={12} md={6}>
                    <Box sx={{ maxWidth: { xs: '100%', md: '90%' }, height: 'auto', borderRadius: 3 }}>
                        {/* Assuming you have a new SVG illustration for tips */}
                        <FundraiserTipsIllustration width="100%" height="auto" />
                    </Box>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Grid container spacing={3}>
                        {tips.map((tip, index) => (
                            <Grid item xs={12} key={index}>
                                <Paper elevation={0} sx={{
                                    p: 3,
                                    textAlign: 'left',
                                    display: 'flex',
                                    alignItems: 'flex-start',
                                    backgroundColor: COLORS.white,
                                    borderRadius: 2,
                                    transition: 'transform 0.3s ease-in-out',
                                    '&:hover': {
                                        transform: 'translateY(-5px)',
                                    }
                                }}>
                                    <Box sx={{ mr: 2, flexShrink: 0, pt: 1 }}>
                                        {tip.icon}
                                    </Box>
                                    <Box>
                                        <Typography variant="h6" fontWeight="bold" color={COLORS.primary} mb={0.5}>
                                            {tip.title}
                                        </Typography>
                                        <Typography variant="body2" color={COLORS.text}>
                                            {tip.description}
                                        </Typography>
                                    </Box>
                                </Paper>
                            </Grid>
                        ))}
                    </Grid>
                </Grid>
            </Grid>
        </Box>
        <Footer />
        </>
    );
};

export default FundraisingTipsPage;